import { createSelector } from 'reselect';
import {
  areHighlightsLoading,
  getHighlights,
  hasHighlightLoadError,
} from 'app/api/redux-jigsaw/userdata/highlights/selectors';
import {
  areBookmarksPending,
  getBookmarks,
  hasBookmarkLoadError,
} from 'app/api/redux-jigsaw/userdata/bookmarks/selectors';
import {
  areNotesPending,
  getNotes,
  hasNoteLoadError,
} from 'app/api/redux-jigsaw/userdata/notes/selectors';

export function isUserActivityLoading(state) {
  return (
    areBookmarksPending(state) ||
    areHighlightsLoading(state) ||
    areNotesPending(state)
  );
}

export function hasUserActivityLoadError(state) {
  return (
    hasBookmarkLoadError(state) ||
    hasHighlightLoadError(state) ||
    hasNoteLoadError(state)
  );
}

function sortUserData(normalizedItems) {
  return normalizedItems.sort((a, b) => {
    if (a.compareDate === b.compareDate) {
      return 0;
    }
    return new Date(a.compareDate) < new Date(b.compareDate) ? 1 : -1;
  });
}

export const getSortedUserActivity = createSelector(
  state => getBookmarks(state),
  state => getHighlights(state),
  state => getNotes(state),
  (bookmarks, highlights, notes) => {
    const fixedBookmarks = bookmarks.map(b => ({
      data: b,
      type: 'bookmark',
      compareDate: b.markedAt,
      key: `bookmark${b.guid}`,
    }));
    const fixedHighlights = highlights.map(h => ({
      data: h,
      type: 'highlight',
      compareDate: h.lastModifiedAt,
      key: `highlight${h.syncId}`,
    }));
    const fixedNotes = notes.map(n => ({
      data: n,
      type: 'note',
      compareDate: n.markedAt,
      key: `note${n.guid}`,
    }));
    const data = [...fixedBookmarks, ...fixedHighlights, ...fixedNotes];
    return sortUserData(data);
  }
);
